import Vue from 'vue'
import Created from '~/mixins/created'

Vue.mixin(Created)
